import { inject, injectable } from 'inversify';
import InAppNotificationService from 'src/features/inAppNotifications/data/service/InAppNotificationsService';
import { UserNotificationsReqParams } from 'src/features/inAppNotifications/data/service/InAppNotificationsService.types';
import { GetUserNotificationsUseCaseInterface } from 'src/features/inAppNotifications/domain/useCases/types';

@injectable()
class GetUserNotificationsUseCase
  implements GetUserNotificationsUseCaseInterface
{
  @inject(InAppNotificationService)
  private inAppNotificationsService!: InAppNotificationService;

  async execute({
    ordering,
    storeSlug,
    accessToken,
  }: UserNotificationsReqParams) {
    const response = await this.inAppNotificationsService.getUserNotifications({
      ordering,
      storeSlug,
      accessToken,
    });

    return response.data;
  }
}

export default GetUserNotificationsUseCase;
